var map = {
	"./blueBoat.png": 3710,
	"./duck1.png": 4326,
	"./duck2.png": 7704,
	"./duck3.png": 3967,
	"./duck4.png": 1184,
	"./duck5.png": 5081,
	"./orangeBoat.png": 2688,
	"./violin_ducky.png": 2324,
	"./yellowBoat.png": 7007
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9835;